import SSRIcon from '@ingka/ssr-icon'
import adjustableBackrest from '@ingka/ssr-icon/paths/adjustable-backrest'
import colourFan from '@ingka/ssr-icon/paths/colour-fan'
import sofa from '@ingka/ssr-icon/paths/sofa'
import sofaBed from '@ingka/ssr-icon/paths/sofa-bed'
import sofaStorage from '@ingka/ssr-icon/paths/sofa-storage'
import washableCover from '@ingka/ssr-icon/paths/washable-cover'
import Text from '@ingka/text'

import type { RangeGalleryData } from '@/features/start-gallery/hooks/use-range-gallery-data'
import { useTranslate } from '@/hooks/use-translate'

type RangeFeaturesProps = {
  rangeGalleryData: RangeGalleryData
}
export function RangeFeatures({ rangeGalleryData }: RangeFeaturesProps) {
  const { translateString } = useTranslate()
  return (
    <>
      <Text textStyle="Caption.S">
        <SSRIcon paths={sofa} />
        &nbsp;{rangeGalleryData.numberOfSofas} {translateString('startpage.card.variations')}
      </Text>
      <Text textStyle="Caption.S">
        <SSRIcon paths={colourFan} />
        &nbsp;{rangeGalleryData.numberOfCovers} {translateString('startpage.card.covers')}
      </Text>
      {rangeGalleryData.hasSofabed && (
        <Text textStyle="Caption.S">
          <SSRIcon paths={sofaBed} />
          &nbsp;
          {translateString(
            rangeGalleryData.hasOnlySofaBeds ? 'startpage.filter.sofa_bed' : 'startpage.card.sofa_bed_options',
          )}
        </Text>
      )}
      {rangeGalleryData.hasStorage && (
        <Text textStyle="Caption.S">
          <SSRIcon paths={sofaStorage} />
          &nbsp;{translateString('startpage.filter.storage')}
        </Text>
      )}
      {rangeGalleryData.hasRecliningBackrest && (
        <Text textStyle="Caption.S">
          <SSRIcon paths={adjustableBackrest} />
          &nbsp;{translateString('startpage.card.recliner')}
        </Text>
      )}
      {rangeGalleryData.hasRemovableCover && (
        <Text textStyle="Caption.S">
          <SSRIcon paths={washableCover} />
          &nbsp;{translateString('common.removable_cover')}
        </Text>
      )}
    </>
  )
}
